import { Link } from '@mui/material'
import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'

export const ContainerFlex = styled('div')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 80%;
    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const ContainerImage = styled('div')(
  ({ theme }) => css`
    @media (max-width: ${theme.screen.medium}) {
      display: none;
    }
  `
)

export const Title = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h8};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const Subtitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h4};
      line-height: ${theme.layout.lineHeight.big};
      color: ${theme.colors.primary.main70};
    }
  `
)

export const Paragraph = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 300;
      font-size: ${theme.typograph.fontsize.h6};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
      max-width: 686px;
    }
  `
)

export const Strong = styled.strong(
  ({ theme }) => css`
    && {
      font-weight: 500;
    }
  `
)

export const CheckBoxLabel = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 500;
      font-size: ${theme.typograph.fontsize.h4};
      line-height: ${theme.layout.lineHeight.big}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const CheckboxLink = styled(Link)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.primary.main70};
    }
  `
)
